import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { gitApi } from '../api/gitApi';
import type { GitCredentialUpsertRequest } from '../types/git.types';

export function useGitCredentials() {
  return useQuery({
    queryKey: ['gitCredentials'],
    queryFn: () => gitApi.listCredentials(),
  });
}

export function useSetGitCredential() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ serverId, body }: { serverId: string; body: GitCredentialUpsertRequest }) =>
      gitApi.setCredential(serverId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['gitCredentials'] });
    },
  });
}

export function useDeleteGitCredential() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (serverId: string) => gitApi.deleteCredential(serverId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['gitCredentials'] });
    },
  });
}
